import { render, staticRenderFns } from "./yu-jia-zai.vue?vue&type=template&id=27242972&scoped=true&"
import script from "./yu-jia-zai.vue?vue&type=script&lang=js&"
export * from "./yu-jia-zai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27242972",
  null
  
)

export default component.exports